export const Constants = {
  TAG_NAME: 'pop-sector-diversification-table-component',
  SECTOR_COLUMN_HEADER: 'Sector',
  PERCENT_OF_PORTFOLIO_COLUMN_HEADER: '% of portfolio',
  PERCENT_OF_BENCHMARK_COLUMN_HEADER: '% of benchmark',
  PERCENT_OF_UNDERWEIGHT_COLUMN_HEADER: '% underweight/overweight',
  EMPTY_CELL_VALUE: 'N/A',
} as const;
